import {PdfDocumentBody} from "../pdf/PdfDocumentBody";
import documentClasses from "../docgen/document.module.css";
import contentBaseClasses from "../contentBase.module.css";

/**
 * The checklist document pane for a related item of PDF type — legacy
 * DocumentViewCollection + PDFPreview parity: the shared docgen header with
 * the related item's name and the PDF pane body (the viewer) filling
 * the rest of the pane. Mounted with `key={topicId}` by the caller, so
 * switching PDFs is a fresh viewer and fresh state.
 */
export const ChecklistPdfView = ({
    topicId,
    name,
}: {
    topicId: string;
    name: string;
}) => (
    <div
        className={`${documentClasses.documentView} ${contentBaseClasses.contentBase}`}
    >
        <header className={documentClasses.documentViewHeader}>
            <h1>{name}</h1>
        </header>
        <PdfDocumentBody topicId={topicId} />
    </div>
);
